import Rest from '../Services/Rest'

/**
 * @typedef {PersonService}
 */
export default class PersonService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/person'

   /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  salvar (record) {    
    return this.post('/save', record)
  }

  
   /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  getOne (id){

    return this.get(`/${id}`)    
  }

    
   /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  getOneByCpf (cpf){
    return this.get(`/cpf/${cpf}`)    
  }

  /**
   * @param {Object} parameters
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  search (parameters = {}) {
    var queryString = ''
    // apply your logic here
    if( Object.keys(parameters).length ){
      var _p = [];
      
      Object.keys(parameters).map(function(key,index){
        _p.push( key+"="+parameters[key] );
      });
      queryString = "?"+ _p.join("&");
    }
    return this.get(`/all${queryString}`).then(response => ({
      items: response.items // just an example
    }))
  }

}